import React, { useEffect, useState } from "react";
import "./hole9_sty.css";
import data from "./holes9_data.json";
import arrow from "../../../../../assets/icons/arrow-up.webp";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { NavLink } from "react-router-dom";

export default function Holes() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [type, setType] = useState({});

  useEffect(() => {
    const fetchBestOf = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/rankings`, {
          params: {
            nom: "9 Holes",
          },
        });

        setType(response.data.type);

      } catch (err) {
        console.error(err);
      }
    };
    fetchBestOf();
    setIsLoading(false);
  }, [baseUrl]);

  if (!isLoading) {

  }

  const latestUpdate = type?.rankings?.reduce((latest, current) => {


    return new Date(current.updated_at) > new Date(latest.updated_at)
      ? current
      : latest;
  }, type?.rankings?.[0]);

  return (
    <div>
      {/* Heading Section */}

      {/* Table Section */}
      <div className="flex flex-col justify-center items-center">
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
          </div>
        ) : type?.rankings ? (
          <div className="lg:flex lg:flex-col lg:justify-center lg:items-center overflow-x-auto w-full px-4">
            <div className="text-center mb-12" id="Holes9">
              <div className="text-3xl md:text-4xl text-center custom-font Inria-font m-8">
                {t("ranking_content.9_holes.9_holes")}
              </div>
              <div className="text-base md:text-lg text-gray-400">
                <div>
                  <h1>
                    {language === "fr"
                      ? `Dernière mise à jour: `
                      : `Last Updated: `}
                    {new Date(latestUpdate.updated_at).toLocaleString(
                      language === "fr" ? "fr-FR" : "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </h1>
                </div>
              </div>
            </div>
            <table className="table-auto w-full md:w-[80vw] border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100 text-gray-600 font-semibold text-sm md:text-base text-start">
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.ranking")}
                  </th>
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.name")}
                  </th>
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.ville")}
                  </th>
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.avis")}
                  </th>
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.rating")}
                  </th>
                  <th className="header_style py-3 px-4">
                    {t("ranking_content.table.total")}
                  </th>
                </tr>
              </thead>
              <tbody className="font-semibold text-lg md:text-xl">
                {type?.rankings?.map((item, index) => (
                  <tr key={item.id} className="border-b border-gray-200">
                    <td className="text-center content_sty py-2 px-4">
                      <div className="flex gap-2 flex-row items-center justify-center">
                        {index + 1}
                        <img src={arrow} width={8} alt="Arrow Icon" />
                      </div>
                    </td>
                    <td className="py-2 px-4 text-green-600">
                      <NavLink to="#" className="whitespace-nowrap">
                        {item.nom}
                      </NavLink>
                    </td>
                    <td className="text-start content_sty py-2 px-4">
                      {item.ville}
                    </td>
                    <td className="text-center content_sty py-2 px-4">
                      {item.nombre}
                    </td>
                    <td className="text-center flex flex-row items-center justify-center gap-2 content_sty py-2 px-4">
                      {item.google}
                      <Stack spacing={1}>
                        <Rating
                          name="half-rating-read"
                          defaultValue={item.google.slice(0, -2)}
                          precision={0.5}
                          readOnly
                        />
                      </Stack>
                    </td>
                    <td className="text-end content_sty py-2 px-4">
                      {item.total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-gray-500"></div>
        )}
      </div>
    </div>
  );
}
